export const mockRandomArr = (arrLength) => Array.from({ length: arrLength }, () => Math.floor(Math.random() * 999999999));
export const highlightMatchingText = (mainText, textToReplace) => {
    const regex = new RegExp(mainText, 'gi');
    return textToReplace.replace(regex, '<mark class="font-bold bg-inherit">$&</mark>');
};
